import { z } from 'zod';
import { INSIGHTS_FACEBOOK_GROUPS, INSIGHTS_FACEBOOK_SELECTABLE_DATE_PRESETS, INSIGHTS_FACEBOOK_TIME_SERIES_CORE_METRICS, INSIGHTS_FACEBOOK_TIME_SERIES_DATE_FIELDS, INSIGHTS_FACEBOOK_TIME_SERIES_DEPRECATED_CORE_METRICS, INSIGHTS_TIME_SERIES_MULTI_OPTION_FIELD_OPERATIONS, INSIGHTS_FACEBOOK_TIME_SERIES_MULTI_OPTION_FIELDS, INSIGHTS_TIME_SERIES_NUMERIC_OPERATIONS, INSIGHTS_FACEBOOK_TIME_SERIES_TEXT_FIELDS, INSIGHTS_TIME_SERIES_TEXT_OPERATIONS, INSIGHTS_FACEBOOK_TIME_SERIES_WIZARD_METRICS, INSIGHTS_TABLE_COLOR_SCHEMAS, } from './constants.js';
export const textMetricsSchema = z.object({
    metricType: z.literal('text'),
    metric: z.enum(INSIGHTS_FACEBOOK_TIME_SERIES_TEXT_FIELDS),
    operation: z.enum(INSIGHTS_TIME_SERIES_TEXT_OPERATIONS),
    value1: z.string().optional(),
    value2: z.string().optional(),
});
export const dateMetricsSchema = z
    .object({
    metricType: z.literal('date'),
    metric: z.enum(INSIGHTS_FACEBOOK_TIME_SERIES_DATE_FIELDS),
    operation: z.enum(['is', 'isnot', 'before', 'after']),
    value: z.date(),
})
    .or(z.object({
    metricType: z.literal('date'),
    metric: z.enum(INSIGHTS_FACEBOOK_TIME_SERIES_DATE_FIELDS),
    operation: z.enum(['btw', 'nbtw']),
    start: z.date(),
    end: z.date(),
}))
    .or(z.object({
    metricType: z.literal('date'),
    metric: z.enum(INSIGHTS_FACEBOOK_TIME_SERIES_DATE_FIELDS),
    operation: z.enum([
        'withinDaysAgo',
        'withinWeeksAgo',
        'withinMonthsAgo',
        'withinYearsAgo',
    ]),
    value: z.number().int(),
}))
    .or(z.object({
    metricType: z.literal('date'),
    metric: z.enum(INSIGHTS_FACEBOOK_TIME_SERIES_DATE_FIELDS),
    operation: z.literal('withinDatePreset'),
    value: z.nativeEnum(INSIGHTS_FACEBOOK_SELECTABLE_DATE_PRESETS),
}));
export const numericalMetricsSchema = z.object({
    metricType: z.literal('numerical'),
    metric: z.enum([
        ...INSIGHTS_FACEBOOK_TIME_SERIES_CORE_METRICS,
        ...INSIGHTS_FACEBOOK_TIME_SERIES_DEPRECATED_CORE_METRICS,
    ]),
    operation: z.enum(INSIGHTS_TIME_SERIES_NUMERIC_OPERATIONS),
    value1: z.number(),
    value2: z.number().optional(),
});
export const multiMetricsSchema = z.object({
    metricType: z.literal('multi'),
    metric: z.enum(INSIGHTS_FACEBOOK_TIME_SERIES_MULTI_OPTION_FIELDS),
    operation: z.enum(INSIGHTS_TIME_SERIES_MULTI_OPTION_FIELD_OPERATIONS),
    value1: z.string().array(),
});
export const actionMetricsSchema = z.object({
    metricType: z.literal('action'),
    metric: z
        .string()
        .startsWith('action:'),
    operation: z.enum(INSIGHTS_TIME_SERIES_NUMERIC_OPERATIONS),
    value1: z.number(),
    value2: z.number().optional(),
});
/** @deprecated */
export const customMetricSchema = z.string().startsWith('custom:');
/** @deprecated */
export const customMetricsSchema = z.object({
    metricType: z.literal('custom'),
    metric: customMetricSchema,
    operation: z.enum(INSIGHTS_TIME_SERIES_NUMERIC_OPERATIONS),
    value1: z.number(),
    value2: z.number().optional(),
});
const wizardMetricsSchema = z.object({
    metricType: z.literal('wizard'),
    metric: z.enum(INSIGHTS_FACEBOOK_TIME_SERIES_WIZARD_METRICS),
    operation: z.enum(INSIGHTS_TIME_SERIES_NUMERIC_OPERATIONS),
    value1: z.number(),
    value2: z.number().optional(),
});
export const metricFilterSchema = z.array(dateMetricsSchema
    .or(textMetricsSchema)
    .or(numericalMetricsSchema)
    .or(multiMetricsSchema)
    .or(actionMetricsSchema)
    .or(customMetricsSchema)
    .or(wizardMetricsSchema)
    .superRefine((output, ctx) => {
    if (output.metricType === 'date') {
        return true;
    }
    const { operation, value1 } = output;
    if (!['isSet', 'isNotSet'].includes(operation) && value1 == null) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Value is required`,
            path: ['value1'],
        });
    }
    if (['btw', 'nbtw'].includes(operation)) {
        if (value1 == null) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Value 1 is required`,
                path: ['value1'],
            });
        }
        else if ('value2' in output && output.value2 == null) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Value 2 is required`,
                path: ['value2'],
            });
        }
        else if ('value2' in output &&
            output.value2 != null &&
            value1 >= output.value2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Value 2 is less than Value 1`,
                path: ['value2'],
            });
        }
    }
}));
export const groupSchema = z
    .enum(INSIGHTS_FACEBOOK_GROUPS)
    .optional()
    .nullable();
export const sortSchema = z.array(z.object({
    id: z.string(),
    desc: z.boolean(),
}));
export const tableColorSchema = z.enum(INSIGHTS_TABLE_COLOR_SCHEMAS);
//# sourceMappingURL=contracts.js.map